import {
  ApiResponse,
  ProjectId,
  ProjectRole,
  ProjectStatsById,
  ProjectWithUserRoles,
  ProjectWithUsers,
  UserId,
  UserPermission,
} from '@clef/shared/types';

import { BaseAPI } from './base_api';
const OrgAdminAPIURLPrefix = 'org_admin';

class OrgAdminAPI extends BaseAPI {
  async getProjectList(): Promise<ApiResponse<ProjectWithUserRoles[]>> {
    return this.get('list_projects');
  }

  async listProjectStats(): Promise<ApiResponse<ProjectStatsById>> {
    return this.get('list_project_stats');
  }

  async getOrgAdminProjectDetails(projectId: ProjectId): Promise<ApiResponse<ProjectWithUsers>> {
    return this.get(`get_project_details`, {
      projectId,
    });
  }

  async transferProjectOwnership(projectId: ProjectId, userId: UserId): Promise<ApiResponse<{}>> {
    return this.postJSON('transfer_project_ownership', { projectId, userId });
  }

  async updateUserPermissions(
    projectId: ProjectId,
    userPermissions: Array<{ id: UserId; permissions: UserPermission[]; isGroupUser?: boolean }>,
  ) {
    return this.postJSON('upsert_project_members', {
      projectId,
      userPermissions,
    });
  }

  async editMemberRole(
    projectId: ProjectId,
    userId: UserId,
    newMemberRole: ProjectRole,
  ): Promise<ApiResponse<{}>> {
    return this.postJSON('change_role', { projectId, memberId: userId, newMemberRole });
  }

  async changeVisibility(projectId: ProjectId, isInviteOnly: boolean) {
    return this.postJSON('set_invite_only', {
      projectId,
      isInviteOnly,
    });
  }

  async deleteUserFromProject(projectId: ProjectId, userId: UserId): Promise<ApiResponse<{}>> {
    return this.delete('delete_user_from_project', { projectId, userId });
  }

  async deleteProject(projectId: ProjectId) {
    return this.postJSON('delete_project', {
      projectId,
    });
  }
}

export default new OrgAdminAPI(OrgAdminAPIURLPrefix);
